import React from 'react';
import { XCircleIcon, CheckCircleIcon, TrendingUpIcon } from 'lucide-react';
export function InactionCostSection() {
  const withoutProtocol = [{
    label: 'Supermercado express sin planificar',
    icon: XCircleIcon
  }, {
    label: 'Delivery 3 veces por semana',
    icon: XCircleIcon
  }, {
    label: 'Desperdicio de comida semanal',
    icon: XCircleIcon
  }];
  const withProtocol = [{
    label: 'Compra inteligente y planificada',
    icon: CheckCircleIcon
  }, {
    label: 'Stockeo cíclico en mayoristas',
    icon: CheckCircleIcon
  }, {
    label: 'Zero Waste — nada se pierde',
    icon: CheckCircleIcon
  }];
  return <section className="w-full bg-[#F5F2EB] py-16 px-4" data-id="element-154" data-mp="3nqxc0ey4b3ur">
      <div className="max-w-5xl mx-auto" data-id="element-155" data-mp="3npcmx4ukod4a">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1B3022] mb-4 text-center" data-id="element-156" data-mp="39sz15jj09pk0">
          El Costo de la Inacción
        </h2>
        <p className="text-lg text-[#5a5a4f] mb-12 text-center max-w-2xl mx-auto" data-id="element-157" data-mp="3et3n3p2onchm">
          Cada mes que pasa sin un sistema, estás perdiendo dinero que podría
          estar en tu bolsillo.
        </p>

        {/* Comparison Table */}
        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-158" data-mp="1kjea63ok9cfg">
          {/* Without Protocol */}
          <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm" data-id="element-159" data-mp="1fj9wsmiy8xtg">
            <h3 className="text-xl font-bold text-[#1a2332] mb-6 text-center" data-id="element-160" data-mp="rtxnznrjarro">
              ❌ Sin el Protocolo
            </h3>
            <ul className="space-y-4 mb-8" data-id="element-161" data-mp="mw5mc2137raa">
              {withoutProtocol.map((item, index) => {
              const Icon = item.icon;
              return <li key={index} className="flex items-center gap-3" data-id="element-162" data-mp="wtk1zzf6sc1j" data-mpi={index}>
                    <Icon className="w-5 h-5 text-[#ef4444] flex-shrink-0" data-id="element-163" data-mp="wr79wtfpslar" />
                    <span className="text-gray-700" data-id="element-164" data-mp="924uztcgt6jy">{item.label}</span>
                  </li>;
            })}
            </ul>
            <div className="border-t border-gray-200 pt-6 text-center" data-id="element-165" data-mp="246vvnphh0rud">
              <p className="text-sm text-gray-500 mb-1" data-id="element-166" data-mp="246m4vzolqgnm">Total mensual</p>
              <p className="text-3xl font-bold text-[#ef4444]" data-id="element-167" data-mp="294ny3dfqrwct">$280.000</p>
              <p className="text-sm text-gray-400" data-id="element-168" data-mp="2dw5pb9ryqikl">CLP / mes</p>
            </div>
          </div>

          {/* With Protocol */}
          <div className="bg-[#f0faf0] rounded-2xl p-8 border-2 border-[#22c55e] shadow-md relative" data-id="element-169" data-mp="2hwzd835enxdh">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2" data-id="element-170" data-mp="1l9kwe4vu9yex">
              <span className="bg-[#22c55e] text-white text-xs font-bold px-4 py-1 rounded-full" data-id="element-171" data-mp="1q6bcutbk2w0v">
                RECOMENDADO
              </span>
            </div>
            <h3 className="text-xl font-bold text-[#1B3022] mb-6 text-center" data-id="element-172" data-mp="1z7rmgyujqu41">
              ✅ Con Solo-Survival
            </h3>
            <ul className="space-y-4 mb-8" data-id="element-173" data-mp="35omudtcv7u2k">
              {withProtocol.map((item, index) => {
              const Icon = item.icon;
              return <li key={index} className="flex items-center gap-3" data-id="element-174" data-mp="3aordzs92l4x0" data-mpi={index}>
                    <Icon className="w-5 h-5 text-[#22c55e] flex-shrink-0" data-id="element-175" data-mp="3kqd3yekro900" />
                    <span className="text-[#1B3022]" data-id="element-176" data-mp="3fstj2vtkcxz3">{item.label}</span>
                  </li>;
            })}
            </ul>
            <div className="border-t border-[#22c55e]/30 pt-6 text-center" data-id="element-177" data-mp="3ayp9s5wtsduu">
              <p className="text-sm text-[#1B3022]/60 mb-1" data-id="element-178" data-mp="36yyky7qv07sy">Total mensual</p>
              <p className="text-3xl font-bold text-[#1B3022]" data-id="element-179" data-mp="321ew6dwjccmr">$200.000</p>
              <p className="text-sm text-[#1B3022]/50" data-id="element-180" data-mp="2x0ra86n5ylze">CLP / mes</p>
            </div>
          </div>
        </div>

        {/* Savings Highlight */}
        <div className="bg-[#1B3022] rounded-2xl px-8 py-8 text-center" data-id="element-181" data-mp="2s2hdvsppdfc7">
          <div className="flex items-center justify-center gap-3 mb-3" data-id="element-182" data-mp="2o1nosw0ixuhq">
            <TrendingUpIcon className="w-8 h-8 text-[#22c55e]" data-id="element-183" data-mp="qbcnt13f4mtz" />
            <h3 className="text-2xl md:text-3xl font-bold text-white" data-id="element-184" data-mp="q8qeox0vpz9n">
              Ahorro Real:
            </h3>
          </div>
          <p className="text-4xl md:text-5xl font-bold text-[#22c55e] mb-2" data-id="element-185" data-mp="tcpa7uvbun8i">
            $80.000 extra
          </p>
          <p className="text-lg text-white/80" data-id="element-186" data-mp="ybsgtjqyh1il">en tu bolsillo cada mes</p>
        </div>
      </div>
    </section>;
}